// The little Markdown engines write inline: **bold**, *italic*, `code` and [label](target). Rendered as text only
// (no HTML), and a link shows its label alone: engines link files by their path on the runner. An italic needs no
// space just inside its stars, so "2 * 3 * 4" stays as it is.
const TOKEN = /(\*\*[^*\n]+\*\*|\*[^*\s](?:[^*\n]*[^*\s])?\*|`[^`\n]+`|\[[^\]\n]+\]\([^)\s]+\))/g;

export function Inline({ text }) {
  return String(text || "").split(TOKEN).map((part, i) => {
    if (i % 2 === 0) return part;
    if (part.startsWith("**")) return <strong key={i} className="font-semibold">{part.slice(2, -2)}</strong>;
    if (part.startsWith("*")) return <em key={i}>{part.slice(1, -1)}</em>;
    if (part.startsWith("`")) return <code key={i} className="font-mono text-[0.95em] px-1 rounded bg-muted">{part.slice(1, -1)}</code>;
    return <span key={i} className="underline decoration-dotted underline-offset-2">{part.slice(1, part.indexOf("]("))}</span>;
  });
}
